import React from "react";
import { connect } from "react-redux";
import { ReactRouter, Router, Route, browserHistory, IndexRoute, Link } from "react-router";
import moment from "moment";
import _ from "lodash";

export default class Events extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      getEventDetails: [],
      gotEventDetails: [],
      limit: 0,
      offset: 0,
      count: 0
    };
  }

  handleClick = (eventId) => {
    browserHistory.push("/events/" + eventId);
  };

  componentWillMount() {
    // Fetch the events from the API connection
    if (this.props.events.length === 0) {
      this.props.fetchEvents(0, 150);
      // this.props.fetchEvents(50);
      // this.props.fetchEvents(100);
    } else {
      this.forceUpdate();
    }
  }

  componentWillUpdate() {
    if (this.props.events !== undefined && Object.keys(this.props.events).length > 0) {
      Object.keys(this.props.events).forEach((key) => {
        let event = this.props.events[key];
        let currentDate = moment().format("D-M-YYYY");
        let checkDate = moment(event.start_datetime).format("D-M-YYYY");

        if (currentDate === checkDate && !this.props.events[key].loading_details) {
          this.props.fetchEventDetails(key);
        }
      });
    }
  }

  render() {
    moment.locale("nl");

    var itemRowsPast = [];
    var itemRows = [];
    var itemRowsFuture = [];
    var lastId = 0;

    if (this.props.events === undefined || this.props.events.length === 0) {
      var row = (
        <div className="event-row" key={lastId}>
          <div className="event-name">Er zijn geen geplande praktijktoetsen</div>
        </div>
      );
      itemRows.push(row);
      itemRowsFuture.push(row);
    } else {
      var currentDate = moment().format("D-M-YYYY");
      var sortedEvents = [];
      Object.keys(this.props.events).forEach((eventId) => {
        let event = this.props.events[eventId];

        // Make sure to check if the current event is not cancelled
        if (!event.is_cancelled) {
          sortedEvents.push(event);
        }
      });

      sortedEvents = _.sortBy(sortedEvents, [
        (o) => {
          return o.start_datetime;
        }
      ]);

      sortedEvents.forEach((event) => {
        let eventId = event.uuid;
        let checkDate = moment(event.start_datetime).format("D-M-YYYY");
        let startDate = moment(event.start_datetime).format("D MMMM");
        let startTime = moment(event.start_datetime).format("HH:mm");
        let endTime = moment(event.end_datetime).format("HH:mm");
        let employerName = "";
        let trainerName = "";

        if (event.employers) {
          employerName = event.employers
            .map(function (employer) {
              return employer.company.name;
            })
            .join(", ");
        }

        var students = {};
        if (event.event_roles !== undefined) {
          event.event_roles.forEach((role) => {
            role.students
              .filter((s) => !s.cancelled)
              .forEach((student) => {
                if (student !== undefined && student.will_attend) {
                  students = {
                    [student.uuid]: true,
                    ...students
                  };
                }
              });
          });
        }

        if (event.trainer && event.trainer.name) {
          trainerName = event.trainer.name;
        }

        if (moment(event.start_datetime).isSame(moment(), "day")) {
          let studentStatus = "Ophalen van cursisten...";
          studentStatus = Object.keys(students).length + " cursisten";

          itemRows.push(
            <div
              className="event-row"
              key={lastId}
              onClick={() => {
                this.handleClick(eventId);
              }}
            >
              <div className="event-name">{event.name}</div>
              <div className="event-timeframe">
                {event.course_id ? `${event.course_id} - ` : ''}{trainerName} - {event.location && event.location.name}
              </div>
              <div className="event-timeframe">
                {startDate}, {startTime} - {endTime}
              </div>
              {employerName !== "" ? <div className="event-employer">{employerName}</div> : ""}
            </div>
          );
        } else if (moment(event.start_datetime).isBefore(moment(), "day")) {
          itemRowsPast.push(
            <div
              className="event-row"
              key={lastId}
              onClick={() => {
                this.handleClick(eventId);
              }}
            >
              <div className="event-name">{event.name}</div>
              <div className="event-timeframe">
                {event.course_id ? `${event.course_id} - ` : ''}{trainerName} - {event.location && event.location.name}
              </div>
              <div className="event-timeframe">
                {startDate}, {startTime} - {endTime}
              </div>
              {employerName !== "" ? <div className="event-employer">{employerName}</div> : ""}
            </div>
          );
        } else {
          itemRowsFuture.push(
            <div
              className="event-row"
              key={lastId}
              onClick={() => {
                this.handleClick(eventId);
              }}
            >
              <div className="event-name">{event.name}</div>
              <div className="event-timeframe">
                {event.course_id ? `${event.course_id} - ` : ''} {trainerName} - {event.location && event.location.name}
              </div>
              <div className="event-timeframe">
                {startDate}, {startTime} - {endTime}
              </div>
              {employerName !== "" ? <div className="event-employer">{employerName}</div> : ""}
            </div>
          );
        }
        lastId++;
      });
    }

    if (itemRows.length === 0) {
      itemRows.push(
        <div className="event-row" key={lastId}>
          Er staat niets op de planning
        </div>
      );
    }
    if (itemRowsFuture.length === 0) {
      itemRowsFuture.push(
        <div className="event-row" key={lastId}>
          Er staat niets op de planning
        </div>
      );
    }

    return (
      <div>
        <div className="event-overview">
          <div className="event-title">Actuele praktijktoetsen</div>
          {itemRows}
        </div>

        {itemRowsPast.length > 0 ? (
          <div className="event-overview">
            <div className="event-title">Nog in te sturen (!)</div>
            {itemRowsPast}
          </div>
        ) : (
          false
        )}

        <div className="event-overview">
          <div className="event-title">Geplande praktijktoetsen</div>
          {itemRowsFuture}
        </div>

        <div className="global-links">
          <Link to="/privacy">Privacy- en cookiebeleid NIBHV</Link>
          <Link to="/terms-of-use">Gebruiksvoorwaarden</Link>
          <span>versie {JSON.parse(COMMIT_HASH)}</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/Events.js